var initSwipers = function initSwipers() {
  var swipers = Array.from(document.querySelectorAll('.swiper-container'));
  for (var i = 0; i < swipers.length; i++) {
    var currentSwiper = swipers[i];
    var id = currentSwiper.id;

    /* global Swiper */
    new Swiper('#' + id, {
      speed: 400,
      spaceBetween: 100,
      threshold: 5,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }
};
var checkSwiper = function checkSwiper() {
  if (typeof window.Swiper !== 'undefined') {
    initSwipers();
    clearInterval(swiperChecker);
  }
};
var swiperChecker = setInterval(checkSwiper, 200);